import React from 'react';
import { useEffect, useState } from "react";
import { Field } from "redux-form";
import { FormGroup, Divider, Popup, Button } from "semantic-ui-react";
import { TextInput, SelectInput, FileInput } from "../../utils/form-fields";
import { ColorPicker } from "../../utils/helpers";

const BackgroundTab = ({ banner, handleUpload, change, template }) => {
  const [mainBgPosOptions, setMainBgPosOptions] = useState([]);
  const [mainBgSizeOptions, setMainBgSizeOptions] = useState([]);
  const [mainBgVerticalOptions, setMainBgVerticalOptions] = useState([]);

  useEffect(() => {
    if (template.variables) {
      const mbpOptions = template.variables.find((item) => {
        return item.uniqueName === "MainBackgroundPosition";
      });
      setMainBgPosOptions(getOptions(mbpOptions.choices));
      const mbsOptions = template.variables.find((item) => {
        return item.uniqueName === "MainBackgroundSize";
      });
      setMainBgSizeOptions(getOptions(mbsOptions.choices));
      const mbvOptions = template.variables.find((item) => {
        return item.uniqueName === "MainBackgroundVertical";
      });
      setMainBgVerticalOptions(getOptions(mbvOptions.choices));
    }
  }, [template]);

  const getOptions = (options) => {
    let choices = [];
    if (!options) return choices;
    options.map((option) => {
      return (choices = [
        ...choices,
        { text: option.value, value: option.value, key: option.value },
      ]);
    });
    return choices;
  };

  return (
    <>
      <FormGroup>
        <Field
          label="Background Colour"
          name={`fields.MainBackgroundColour`}
          type="text"
          component={TextInput}
        >
          <ColorPicker
            presetColors={template.colorPresets}
            color={banner.fields.MainBackgroundColour}
            colorPickerType="hex"
            onSelect={(col) => {
              change(`fields.MainBackgroundColour`, col);
            }}
          />
        </Field>
        <div className="field popup">
          <Popup
            content="Use this instead of a background image if you only need a flat background colour"
            trigger={<Button icon="question" />}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <div className="field">
          <label>Main Background Image</label>
          {banner.fields &&
            banner.fields.MainBackgroundImage &&
            banner.fields.MainBackgroundImage.path && (
              <>
                <p>
                  {Math.round(banner.fields.MainBackgroundImage.size / 1000)} kb
                </p>
                <img
                  src={banner.fields.MainBackgroundImage.path}
                  alt="Main background"
                />
              </>
            )}
          <Field
            name={`fields.MainBackgroundImage`}
            component={FileInput}
            fileName={
              banner.fields &&
              banner.fields.MainBackgroundImage &&
              banner.fields.MainBackgroundImage.name
                ? banner.fields.MainBackgroundImage.name
                : ""
            }
            callback={(file) =>
              handleUpload(
                file,
                `fields.MainBackgroundImage`,
                "Main Background Image",
                { maxWidth: 2544, maxHeight: 264 }
              )
            }
            handleFileRemove={(e) => change(`fields.MainBackgroundImage`, {})}
          />
        </div>
        <Field
          options={mainBgPosOptions}
          component={SelectInput}
          label="Horizontal position"
          type="text"
          name={`fields.MainBackgroundPosition`}
        />
        <div className="field popup">
          <Popup
            content="Choose where the background image will start horizontally: left, right or center"
            trigger={<Button icon="question" />}
          />
        </div>
        <Field
          options={mainBgVerticalOptions}
          component={SelectInput}
          label="Vertical position"
          type="text"
          name={`fields.MainBackgroundVertical`}
        />
        <div className="field popup">
          <Popup
            content="Choose where the background image will start vertically: top, center or bottom"
            trigger={<Button icon="question" />}
          />
        </div>
        <Field
          options={mainBgSizeOptions}
          component={SelectInput}
          label="Size"
          type="text"
          name={`fields.MainBackgroundSize`}
        />
        <div className="field popup">
          <Popup
            content="'Cover' tries to fill the entire background. 'Contain' shows the entire image and keeps its aspect ratio."
            trigger={<Button icon="question" />}
          />
        </div>
      </FormGroup>
      <Divider hidden />
      <FormGroup>
        <div className="field">
          <label>Additional Background Image</label>
          {banner.fields &&
            banner.fields.ExtraBackgroundImage &&
            banner.fields.ExtraBackgroundImage.path && (
              <>
                <p>
                  {Math.round(banner.fields.ExtraBackgroundImage.size / 1000)}{" "}
                  kb
                </p>
                <img
                  src={banner.fields.ExtraBackgroundImage.path}
                  alt="Additional background"
                />
              </>
            )}
          <Field
            name={`fields.ExtraBackgroundImage`}
            component={FileInput}
            fileName={
              banner.fields &&
              banner.fields.ExtraBackgroundImage &&
              banner.fields.ExtraBackgroundImage.name
                ? banner.fields.ExtraBackgroundImage.name
                : ""
            }
            callback={(file) =>
              handleUpload(
                file,
                `fields.ExtraBackgroundImage`,
                "Additional Background Image",
                { maxWidth: 750, maxHeight: 264 }
              )
            }
            handleFileRemove={(e) => change(`fields.ExtraBackgroundImage`, {})}
          />
        </div>
        <Field
          component={TextInput}
          name={`fields.ExtraBackgroundSize`}
          type="text"
          label="Size (px)"
        />
        <Field
          component={TextInput}
          name={`fields.ExtraBackgroundPositionFromLeft`}
          type="text"
          label="Position from left (% or px)"
        />
        <Field
          component={TextInput}
          name={`fields.ExtraBackgroundPositionFromTop`}
          type="text"
          label="Position from top (px)"
        />
      </FormGroup>
    </>
  );
};

export default BackgroundTab;
